import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'

import { router } from '@/router'
import { queryClient } from '@/lib/query-client'
import { ensureCsrf } from '@/lib/api'
import './globals.css'

/**
 * Entry point — substitui o `src/app/layout.tsx` + runtime do Next.js.
 *
 * O cookie XSRF-TOKEN é buscado antes de montar o app: o guard de rota chama
 * `/api/auth/me` logo em seguida, e qualquer POST subsequente (login inclusive)
 * já encontra o token no lugar.
 */
async function bootstrap() {
  await ensureCsrf().catch(() => {
    // Backend fora do ar: deixa o app montar mesmo assim — as telas mostram
    // o próprio estado de erro em vez de uma tela branca.
  })

  const rootEl = document.getElementById('root')
  if (!rootEl) throw new Error('#root não encontrado em index.html')

  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
}

void bootstrap()
